// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"124":"72b79a94","360":"fe8d1484"}[chunkId] + ".css";
};